import qs from "qs";
import axios from "axios";
import Jsona from "jsona";

const url = process.env.VUE_APP_API_BASE_URL;
const jsona = new Jsona();

function list(params) {
  const options = {
    params: params,
    paramsSerializer: function (params) {
      return qs.stringify(params, { encode: false });
    },
  };

  return axios.get(`${url}/bid-steps`, options).then((response) => {
    return {
      list: jsona.deserialize(response.data),
      meta: response.data.meta,
    };
  });
}

function get(id) {
  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json",
    },
  };

  return axios
    .get(`${url}/bid-steps/${id}?include=auction`, options)
    .then((response) => {
      let bidStep = jsona.deserialize(response.data);
      delete bidStep.links;
      return bidStep;
    });
}

function add(bidStep) {
  const payload = jsona.serialize({
    stuff: bidStep,
    includeNames: null,
  });

  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json",
    },
  };

  return axios
    .post(`${url}/bid-steps?include=`, payload, options)
    .then((response) => {
      return jsona.deserialize(response.data);
    });
}

function update(bidStep) {
  const payload = jsona.serialize({
    stuff: bidStep,
    includeNames: [],
  });

  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json",
    },
  };

  return axios
    .patch(`${url}/bid-steps/${bidStep.id}?include=`, payload, options)
    .then((response) => {
      return jsona.deserialize(response.data);
    });
}

function destroy(id) {
  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json",
    },
  };

  return axios.delete(`${url}/bid-steps/${id}`, options);
}
export default {
  list,
  get,
  add,
  update,
  destroy,
};
